<template>
    <div class="general-modal">
        <BaseModal :padding="isMobileOrTablet ? MODAL_PADDING_MOBILE : MODAL_PADDING_DESKTOP"
                   maxWidth="520px"
                   useContentFullHeight
                   useClickOutsideClose
                   @close="handleClose">
            <template #header>
                <img :src="asset_cdn('assets/missions/notifications/notifications-arrow.png')"
                     class="header-arrow"
                     :width="arrowWidth"
                     :height="arrowHeight"
                     alt="arrow to notification"
                     title="arrow to notification">
            </template>
            <template #content>
                <div class="general-modal__content general-modal__content--justify-center">
                    <div class="general-modal__image">
                        <img :src="asset_cdn('assets/missions/completed.png')"
                             :width="64"
                             :height="64"
                             alt="notification"
                             title="notification">
                    </div>
                    <h2 class="general-modal__title">
                        <Translate translationKey="quests-dashboard.extensionConnected"
                                   fallback="Extension Connected — Just One Step to Start Earning!" />
                    </h2>
                    <div class="general-modal__subtitle">
                        <Translate translationKey="quests-dashboard.openTheBitDegreeExtension"
                                   fallback="Open the BitDegree extension now to activate mining and start earning instantly." />
                    </div>
                </div>
            </template>
            <template #footer/>
        </BaseModal>
    </div>
</template>

<script setup lang="ts">
    import BaseModal from '@/js/components/BaseModal.vue';
    import { ModalEnum, useModalStore } from '@/js/store/quests/game/modules/ModalStore';
    import { useModalActive } from '@/js/composables/useModalActive';
    import { asset_cdn } from '@/js/helpers/helpers';
    import { useDeviceSize } from '@/js/composables/useDeviceSize';
    import { MODAL_PADDING_DESKTOP, MODAL_PADDING_MOBILE } from '@/js/quests/global/constants/modal';

    const modalStore = useModalStore();

    const { isMobileOrTablet } = useDeviceSize();

    const arrowWidth = '85';
    const arrowHeight = '191';

    const handleClose = () => {
        modalStore.toggleModal(ModalEnum.EXTENSION_CONNECTED, false);
    };

    useModalActive();
</script>

<style scoped lang="scss">
@use "@/sass/partials/breakpoints" as breakpoints;
@use "@/js/quests/dashboard/sass/mixins/_modal" as modalMixins;

.general-modal {
    @include modalMixins.modal;

    &__image {
        margin-bottom: 16px;

        img {
            width: 64px;
            height: 64px;
        }
    }

    &__title {
        margin-bottom: 32px;
        font-weight: 700;
    }
}

.header-arrow {
    position: absolute;
    top: 0;
    right: 0;
    transform: translateY(-50%) translateX(100%) scale(-1, 1);

    @media (max-width: breakpoints.$md-breakpoint-max-width) {
        display: none;
    }
}
</style>
